import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext.js';
import { AppLayout } from './layouts/AppLayout.js';

import { Login } from './pages/Login.js';
import { Dashboard } from './pages/Dashboard.js';
import { Projects } from './pages/Projects.js';
import { Lessons } from './pages/Lessons.js';
import { NewLesson } from './pages/NewLesson.js';
import { LessonEditor } from './pages/LessonEditor.js';
import { Processings } from './pages/Processings.js';
import { VideoLibrary } from './pages/VideoLibrary.js';
import { MyPlan } from './pages/MyPlan.js';
import { QuotaHistory } from './pages/QuotaHistory.js';
import { MyAccount } from './pages/MyAccount.js';
import { Transfers } from './pages/Transfers.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<AppLayout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/projetos" element={<Projects />} />
              <Route path="/aulas" element={<Lessons />} />
              <Route path="/aulas/:id/editor" element={<LessonEditor />} />
              <Route path="/nova-videoaula" element={<NewLesson />} />
              <Route path="/processamentos" element={<Processings />} />
              <Route path="/transferencias" element={<Transfers />} />
              <Route path="/biblioteca" element={<VideoLibrary />} />
              <Route path="/meu-plano" element={<MyPlan />} />
              <Route path="/historico-consumo" element={<QuotaHistory />} />
              <Route path="/minha-conta" element={<MyAccount />} />
              <Route
                path="/minha-conta/integracoes/google-drive"
                element={<Navigate to="/minha-conta?tab=integracoes" replace />}
              />
              <Route
                path="/integracoes/google-drive"
                element={<Navigate to="/minha-conta?tab=integracoes" replace />}
              />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
